import styled from 'styled-components';
import { Grid, GridProps } from '@mui/material';
import { colors } from 'spw-theme';
import React from 'react';

export const GridRow = styled((props: GridProps) => (
  <Grid justifyContent="space-evenly" wrap="nowrap" container {...props} />
))`
  && {
    background-color: ${colors.lightGreyBackground} !important;
    border-bottom: 1px solid ${colors.containerBorder};
    height: 52px;
  }

  &.draggable {
    cursor: pointer;
    div.MuiGrid-item {
      cursor: pointer !important;
    }
  }

  &.header {
    height: 40px;
    background: ${colors.backgroundGrey} !important;
    cursor: default;
  }

  &.top-header {
    background: ${colors.white} !important;
    height: 80px;
  }

  &.top-header.subcategory {
    min-height: 80px;
    max-height: 88px;
    height: auto;
  }

  &.top-header.subcategory > div {
    border-bottom: 0;
  }

  &.top-header.sticky {
    height: 96px;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  &.active {
    background-color: ${colors.backgroundGrey} !important;
  }

  &.hover {
    background-color: ${colors.backgroundGrey} !important;
  }

  &.tall {
    height: 68px;
  }

  &.white-background {
    background-color: ${colors.white} !important;
  }
`;

export const GridColumn = styled((props: GridProps) => (
  <Grid item {...props} />
))`
  && {
    display: flex;
    height: inherit;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    justify-content: flex-end;
    align-items: center;
    padding-right: 8px;
    padding-left: 8px;
    text-align: right;
    border-bottom: 1px solid ${colors.containerBorder};
    cursor: default;

    span.smaller {
      color: ${colors.darkerGray};
      font-size: 12px;
      text-align: right;
    }

    span.nowrap {
      white-space: nowrap;
    }
  }

  &.row-start {
    text-align: left;
    padding-right: 0;
  }

  & > .space-allocation-wrapper.shaded {
    background-color: rgba(3, 178, 171, 0.1);
    padding: 0 8px;
    height: 100%;
    display: flex;
    align-items: center;
    transform: translateX(8px);
  }

  &.lighter {
    background-color: ${colors.white};
  }

  &.error {
    color: ${colors.red} !important;
  }

  &.justifyCenter {
    justify-content: center;
  }

  &.justify-start {
    justify-content: flex-start;
  }

  &.seat-percent-column {
    padding-right: 48px;
  }

  &.seat-percent-column.justify-start {
    padding-left: 104px;
  }

  &.seat-percent-column.justify-start.nowrap {
    white-space: nowrap;
  }

  &.align-start {
    align-items: flex-start;
  }
`;

export const ProgramSubtotal = styled('div')<{ margin?: string }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-align: right;
  color: ${colors.black};
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  align-items: flex-end;
  margin: ${(props) => props.margin || '0px'};
`;

export const CategorySubHeader = styled('div')<{ marginLeft?: string }>`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin-left: ${(props) => props.marginLeft};
  color: ${colors.black};
  white-space: nowrap;
  cursor: default;
`;

export const RowTitle = styled.div`
  p {
    margin: 0px;
    width: 138px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &.subtitle {
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  span {
    font-size: 12px;
    white-space: nowrap;
  }
`;

export const RowWrapper = styled.div`
  scroll-margin-top: 200px;
`;
